import React from 'react'
import InterviewTopic from '../Pages/Interview/SelectTopic/InterviewTopic'

function SelectTopic() {
  return (
    <>
        <InterviewTopic />
    </>
  )
}

export default SelectTopic
